export default {
  path: '/process',
  name: 'Process',
  meta: {
    title: '加工',
    showTabBar: true
  },
  redirect: {
    name: 'ProcessList'
  },
  component: () => import('@/views/layout/HomeLayout'),
  children: [
    {
      path: 'process-list',
      name: 'ProcessList',
      meta: {
        title: '加工管理',
        showTabBar: true
      },
      component: () => import('@/views/Process')
    },
    {
      path: 'partially-prepared-products',
      name: 'PartiallyPreparedProducts',
      meta: {
        title: '半成品',
        showTabBar: true
      },
      component: () => import('@/views/partiallyPreparedProducts')
    }
  ]
}

